import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { actions as signAppointmentConsentActions } from '../../redux/healthboard/requests/sign-appointment-consent-req';

const useSignAppointmentConsent = ({ consentId, userId, consentVersion }) => {
  const dispatch = useDispatch();

  return useCallback(
    ({ outcomeTitle } = {}) => {
      const consentPayload = {
        ...(outcomeTitle ? { outcome_title: outcomeTitle } : {}),
      };

      dispatch(
        signAppointmentConsentActions.send({
          consentId,
          user_consent_info: {
            accepted: true,
            user_id: userId,
            version: consentVersion,
            ...consentPayload,
          },
        }),
      );
    },
    [dispatch, consentId, userId, consentVersion],
  );
};

export default useSignAppointmentConsent;



// WEBPACK FOOTER //
// ./src/hooks/consents/useSignAppointmentConsent.js